<template>
  <ContentLayout :mediumHeader="true">
    <template #header>
      <h4>{{ title }}</h4>

      <div class="input">
        <span class="input--text">Procurar por ano (> {{ minYear}}) </span>
        <input class="input--field" :class="{ invalid: !validYear}" type="number" :min="minYear" :max="currentYear" v-model="selectedYear" />
      </div>
    </template>

    <div>
      <pdf-viewer v-if="year" :source="'./pdf/'+ directory +'/'+ year +'.pdf'" />
    </div>
  </ContentLayout>
</template>

<script>
import ContentLayout from './ContentLayout';

export default {
  components: {
    ContentLayout
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    minYear: {
      type: Number,
      default: 1900
    },
    directory: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    currentYear: new Date().getFullYear(),
    selectedYear: null
  }),
  computed: {
    year() {
      if (!this.selectedYear || this.selectedYear.length !== 4 ||
          this.selectedYear > this.currentYear || this.selectedYear <= this.minYear
      ) {
        return 9999;
      }

      return this.selectedYear;
    },
    validYear() {
      let valid = true;
      const year = parseInt(this.selectedYear);

      if (!year) {
        return valid
      }

      if (year.length > 4 || year > this.currentYear || year <= this.minYear) {
        valid = false
      }

      return valid
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  flex-basis: 100%;

  .input--text {
    font-weight: bold;
    font-size: 1.4rem;
  }

  .input--field {
    padding: 8px;
    border: 2px solid #5280e9;
    border-radius: 2px;
    font-weight: bold;
    font-size: 1.1rem;

    &.invalid {
      border: 2px solid #e95252;
    }
  }
}

@media (max-width: 900px) {
  .input {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .input--text {
      font-size: 1.1rem;
    }

    .input--field {
      width: 155px;
    }
  }
}
</style>
